import React from 'react'
import { BasePreDetail } from 'App/Screens/SubModules/Component'
import { PermissionName } from 'App/Config'
import PageDetail from './Detail'

class RateTypeManagement extends BasePreDetail {
  constructor(props) {
    super(props)

    this.appName = 'jobs'
    this.modelName = 'ratetype'
    this.availablePermissions = ['.view_']
    this.codePart = props.match.params.id === 'add' ? PermissionName.CREATE.codePart : PermissionName.READ.codePart
    const isAccessAllowed = this.availablePermissions.find(val => val.search(this.codePart) !== -1)
    this.state = {
      ...this.state,
      isAccessAllowed,
      currentPermissionSet: this.isSuperuser ? this.availablePermissions : [],
    }
  }

  getPageDetail = () => <PageDetail {...this.props} currentPermissionSet={this.state.currentPermissionSet} />
}

export default RateTypeManagement